import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';

const SHOW_ON = ['/', '/business', '/blog', '/about', '/faq'];

export function MobileStickyCTA() {
    const { t } = useLanguage();
    const location = useLocation();
    const [visible, setVisible] = useState(false);

    const enabled = SHOW_ON.includes(location.pathname) || location.pathname.startsWith('/blog/');

    useEffect(() => {
        if (!enabled) {
            setVisible(false);
            return;
        }
        const handler = () => setVisible(window.scrollY > 500);
        handler();
        window.addEventListener('scroll', handler, { passive: true });
        return () => window.removeEventListener('scroll', handler);
    }, [enabled, location.pathname]);

    if (!enabled) return null;

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80 }}
                    animate={{ y: 0 }}
                    exit={{ y: 80 }}
                    transition={{ duration: 0.25 }}
                    className="md:hidden fixed bottom-3 left-3 right-3 z-40 rounded-[22px] bg-white/30 backdrop-blur-2xl backdrop-saturate-150 border border-white/60 shadow-[0_10px_36px_rgba(15,23,42,0.12),inset_0_1px_0_rgba(255,255,255,0.7)] px-4 pt-3"
                    style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom) * 0.5)' }}
                    data-testid="mobile-sticky-cta-bar"
                >
                    <div className="flex items-center justify-between gap-4">
                        <div>
                            <p className="text-base font-bold text-foreground leading-tight">
                                €35 <s className="text-muted-foreground font-normal text-sm">€45</s>
                            </p>
                            <p className="text-[11px] text-muted-foreground leading-tight">{t('banner.ships_value')}</p>
                        </div>
                        <Link
                            to="/checkout"
                            data-testid="mobile-sticky-cta"
                            className="btn-primary flex-1 max-w-[220px] text-center text-sm py-3 !px-4 whitespace-nowrap"
                        >
                            Pre-order
                        </Link>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
